import { useRef,useState, useEffect } from "react";
import axiosInstance from "../services/axiosInstance";
import Loader from "../components/Loader";
import Lookup from "../components/Lookup";
import { FaSearch } from "react-icons/fa";

function TeacherMapping() {
  const [mappings, setMappings] = useState([]);
    const [loading, setLoading] = useState(false);
  const [selectedMapping, setSelectedMapping] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const hasFetched = useRef(false);
  // const [query, setQuery] = useState("");
  // const [ setResults] = useState([]);
  // const [ setShowResults] = useState(false);
  //const [showLookup, setShowLookup] = useState(false);
  const [activeLookup, setActiveLookup] = useState(null);




    useEffect(() => {
        if (hasFetched.current) return;
        hasFetched.current = true;
        fetchMappings();
    }, []);
    const fetchMappings = async () => {
        try {
        setLoading(true);
        const response = await axiosInstance.get("/mapping");
        setMappings(response.data);
        } catch (err) {
        alert("Failed to load Mappings,Please retry");
        } finally {
        setLoading(false);
        }
    };
  const handleSave  = async () => {//Save Logic
    try {
        setLoading(true);
        const response = await axiosInstance.post("/mapping/save", selectedMapping);
        if (response.data.status === "SUCCESS") {
            alert("Saved successfully");
            setShowModal(false);
            setSelectedMapping(null);
            fetchMappings();
        } else {
            if (response.data.errors && response.data.errors.length > 0) {
                alert(response.data.errors.join("\n")); // show all errors
            } else {
                alert(response.message || "Error in Save");
            }
        }
    } catch (errors) {
        alert("Error in Save");
    }finally{
        setLoading(false);
    }
  };

  const handleEdit = (mapping) => {
    setSelectedMapping(mapping);
    setShowModal(true);
  };

  const handleNew = () => {
    setSelectedMapping({
      employeeId: "",
      classId: "",
      sectionId: "",
      academicYearId: "",
      subjectId: ""
    });
    setShowModal(true);
  };

  // const handleSearch = () => {
  //   // Replace with your API call
  //   fetch(`/api/search?query=${query}`)
  //     .then((res) => res.json())
  //     .then((data) => {
  //       setResults(data);
  //       setShowResults(true);
  //     });
  // };

  // const handleSelect = (item) => {
  //   setQuery(item.name); // populate field with selected row
  //   setShowResults(false);
  // };


  return (
    <div>
      <div className="flex justify-between items-center mb-6">
             {loading && <Loader />}
             <h2 className="text-2xl font-bold">Teacher Class Mapping</h2>
     
             <div className="flex gap-3">
     
             {/* New Mapping Button */}
               <button
                    onClick={handleNew}
                    className="bg-blue-600 text-white px-4 py-2 rounded"
                >
                 + New
               </button>
             </div>
           </div>

      {/* Table of results */}
      <div className="bg-white shadow rounded-xl overflow-x-auto">
      <table className="w-full text-left">
       <thead className="bg-gray-100 text-gray-600">
          <tr>
            <th className="px-4 py-2 border">Teacher</th>
            <th className="px-4 py-2 border">Class</th>
            <th className="px-4 py-2 border">Section</th>
            {/* <th className="px-4 py-2 border">Academic Year ID</th> */}
            {/* <th className="px-4 py-2 border">Subject</th> */}
            <th className="px-4 py-2 border">Actions</th>
          </tr>
        </thead>
        <tbody>
          {mappings.map((m) => (
            <tr key={m.id} className="hover:bg-gray-50">
              <td className="px-4 py-2 border">{m.employeeName}</td>
              <td className="px-4 py-2 border">{m.className}</td>
              <td className="px-4 py-2 border">{m.sectionName}</td>
              {/* <td className="px-4 py-2 border">{m.academicYearId}</td> */}
              {/* <td className="px-4 py-2 border">{m.subject}</td> */}
              <td className="px-4 py-2 border">
                <button
                  onClick={() => handleEdit(m)}
                  className="bg-blue-500 text-white px-3 py-1 rounded"
                >
                  Edit
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Popup Modal */}
      {showModal && (
         <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center p-4 z-50">
            {loading && <Loader />}
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-5xl p-6 relative">
            <h2 className="text-lg font-semibold mb-4">
              {selectedMapping.id ? "Edit Mapping" : "New Mapping"}
            </h2>
             {/* Grid Form */}
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 text-sm">
            {/* Input with magnifier icon */}
           <div>
            <label className="block mb-2">Employee</label>
            <div className="flex items-center border rounded px-2 py-1 w-80">
                <input
                type="text"
                value={selectedMapping.employeeName}
                className="flex-grow px-2 py-1 focus:outline-none"
                placeholder="Select employee..."
                onChange={(e) =>
                      setSelectedMapping({
                        ...selectedMapping,
                        employeeName: e.target.value
                      })
                    }
                />
                <button
                 onClick={() => setActiveLookup("EMPLOYEE")}
                className="text-gray-500 hover:text-blue-600"
                >
                <FaSearch />
                </button>
            </div>
            <Lookup isOpen={activeLookup === "EMPLOYEE"} onClose={() => setActiveLookup(null)}
                onSelect={(emp) => setSelectedMapping({ ...selectedMapping, employeeId: emp.id, employeeName: emp.name })} 
                lookupConfig={{ type: "EMPLOYEE", attributes: { name: selectedMapping.employeeName} }} 
                inputValue={selectedMapping.employeeName}/>
            </div>
           
            {/* Input with magnifier icon */}
           <div>
            <label className="block mb-2">Class</label>
            <div className="flex items-center border rounded px-2 py-1 w-80">
                <input
                type="text"
                value={selectedMapping.className}
                className="flex-grow px-2 py-1 focus:outline-none"
                placeholder="Select employee..."
                onChange={(e) =>
                      setSelectedMapping({
                        ...selectedMapping,
                        className: e.target.value
                      })
                    }
                />
                <button
                 onClick={() => setActiveLookup("CLASS")}
                className="text-gray-500 hover:text-blue-600"
                >
                <FaSearch />
                </button>
            </div>
            <Lookup isOpen={activeLookup === "CLASS"} onClose={() => setActiveLookup(null)}
                onSelect={(cls) => setSelectedMapping({ ...selectedMapping, classId: cls.id, className: cls.name })} 
                lookupConfig={{ type: "CLASS", attributes: { name: selectedMapping.className} }} 
                inputValue={selectedMapping.className}/>
            </div>
            

             {/* Input with magnifier icon */}
           <div>
            <label className="block mb-2">Section</label>
            <div className="flex items-center border rounded px-2 py-1 w-80">
                <input
                type="text"
                value={selectedMapping.sectionName}
                className="flex-grow px-2 py-1 focus:outline-none"
                placeholder="Select employee..."
                onChange={(e) =>
                      setSelectedMapping({
                        ...selectedMapping,
                        sectionName: e.target.value
                      })
                    }
                />
                <button
                onClick={() => setActiveLookup("SECTION")}
                className="text-gray-500 hover:text-blue-600"
                >
                <FaSearch />
                </button>
            </div>
            <Lookup isOpen={activeLookup === "SECTION"} onClose={() => setActiveLookup(null)}
                onSelect={(sec) => setSelectedMapping({ ...selectedMapping, sectionId: sec.id, sectionName: sec.name })} 
                lookupConfig={{ type: "SECTION", attributes: { id: selectedMapping.classId} }} 
                inputValue={selectedMapping.classId}/>
            </div>
            </div>
            <div className="flex justify-end space-x-2 mt-4">
              <button
                onClick={() => {
                  setShowModal(false);
                  setSelectedMapping(null);
                }}
                className="bg-gray-400 text-white px-4 py-2 rounded hover:bg-gray-500"
              >
                Cancel
              </button>
              <button
                onClick={handleSave}
                className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}
      </div>
    </div>
  );
}

export default TeacherMapping;